// Logo URLs
export const logos = {
  iconOnly: 'https://customer-assets.emergentagent.com/job_study-abroad-elite/artifacts/4fcb4cnl_Chris-IELTS-COnsulting-Raipur-Chris-Sir%20%281%29.png',
  withText: 'https://customer-assets.emergentagent.com/job_study-abroad-elite/artifacts/fz51o938_Chris-IELTS-COnsulting-Raipur-Chris-Sir.png',
};

// Navigation
export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Destinations', href: '#destinations' },
  { label: 'Visa Services', href: '#visa-services' },
  { label: 'Reviews', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

// Hero
export const heroContent = {
  headline: 'Your Gateway to',
  headlineAccent: 'Global Education',
  subheadline: 'Expert IELTS & TOEFL coaching and personalized study abroad guidance from Chhattisgarh\'s most trusted education consultant. Proven results, personalized coaching, end-to-end support since 2009.',
  ctaPrimary: 'Book Free Demo',
  ctaSecondary: 'WhatsApp Now',
  whatsappNumber: '919229299937',
  badges: ['IELTS Expert', '3000+ Students', '20+ Countries'],
};

// Country marquee for hero ticker
export const countryTicker = [
  'Canada', 'United Kingdom', 'USA', 'Australia', 'New Zealand', 'Germany',
  'Japan', 'Singapore', 'Malaysia', 'Switzerland', 'Sweden', 'Finland',
  'Turkey', 'France', 'Dubai', 'Armenia', 'Russia', 'Kazakhstan', 'Hungary', 'Georgia',
];

// Trust Stats
export const trustStats = [
  { value: 15, suffix: '+', label: 'Years Experience', icon: 'Award' },
  { value: 3000, suffix: '+', label: 'Students Guided', icon: 'Users' },
  { value: 98, suffix: '%', label: 'Visa Success Rate', icon: 'TrendingUp' },
  { value: 20, suffix: '+', label: 'Countries Covered', icon: 'Globe' },
];

// Services
export const services = [
  {
    title: 'IELTS Coaching',
    description: 'Personalized IELTS training with proven strategies to achieve your target band score. Small batches, focused modules, and regular mock tests covering Listening, Reading, Writing & Speaking.',
    icon: 'BookOpen',
    features: ['Band 7+ Strategy', 'Mock Tests Weekly', 'Small Batch Size', '1-on-1 Doubt Sessions'],
  },
  {
    title: 'TOEFL Coaching',
    description: 'Achieve your target TOEFL score with expert coaching! Personalized strategies, practice tests, and comprehensive training for all four sections: Reading, Listening, Speaking, and Writing.',
    icon: 'Languages',
    features: ['All 4 Sections Covered', 'Practice Tests', 'Score Improvement Plan', 'Expert Faculty'],
  },
  {
    title: 'Study Abroad Consulting',
    description: 'End-to-end guidance for studying in top universities across the globe. From university shortlisting to admission support — we handle everything.',
    icon: 'GraduationCap',
    features: ['University Shortlisting', 'Application Support', 'Profile Evaluation', 'Scholarship Guidance'],
  },
  {
    title: 'University Admission Assistance',
    description: 'Seamless university admissions with study visa assistance and accommodation support. Expert guidance for a hassle-free journey to your dream destination!',
    icon: 'School',
    features: ['Course Selection', 'Application Filing', 'Scholarship Assistance', 'Accommodation Support'],
  },
  {
    title: 'Visa Assistance',
    description: 'Complete visa documentation and interview preparation with expert guidance for a hassle-free visa application process. 99% visa approval rate!',
    icon: 'ShieldCheck',
    features: ['Documentation Support', 'Interview Prep', 'Financial Guidance', 'Post-Landing Help'],
  },
  {
    title: 'SOP & LOR Writing',
    description: 'Professional Statement of Purpose and Letter of Recommendation writing that makes your application stand out from the crowd.',
    icon: 'PenTool',
    features: ['Custom SOP Writing', 'LOR Assistance', 'Resume Building', 'Essay Review'],
  },
];

// Featured Destinations (with images)
export const destinations = [
  {
    country: 'Canada',
    tagline: 'Top Choice for Indian Students',
    universities: '96+ Universities',
    image: 'https://images.unsplash.com/photo-1549529400-9ad5816f432e?w=800&q=80',
    highlights: ['Post-Study Work Permit', 'Affordable Tuition', 'PR Pathway'],
  },
  {
    country: 'United Kingdom',
    tagline: 'World-Class Education Heritage',
    universities: '130+ Universities',
    image: 'https://images.unsplash.com/photo-1649162549612-63314ee73470?w=800&q=80',
    highlights: ['1-Year Masters', 'Graduate Route Visa', 'Rich Culture'],
  },
  {
    country: 'United States',
    tagline: 'Land of Opportunities',
    universities: '200+ Universities',
    image: 'https://images.unsplash.com/photo-1496588152823-86ff7695e68f?w=800&q=80',
    highlights: ['OPT/CPT Programs', 'Research Excellence', 'Diverse Campuses'],
  },
  {
    country: 'Australia',
    tagline: 'Innovation Meets Nature',
    universities: '43+ Universities',
    image: 'https://images.unsplash.com/photo-1523059623039-a9ed027e7fad?w=800&q=80',
    highlights: ['Post-Study Work Rights', 'Quality of Life', 'Part-Time Work'],
  },
  {
    country: 'New Zealand',
    tagline: 'Education in Paradise',
    universities: '8 Universities',
    image: 'https://images.unsplash.com/photo-1465056836041-7f43ac27dcb5?w=800&q=80',
    highlights: ['Safe Environment', 'Work While Study', 'PR Opportunities'],
  },
  {
    country: 'Europe',
    tagline: 'Diverse Cultures, One Dream',
    universities: '500+ Universities',
    image: 'https://images.unsplash.com/photo-1609971757431-439cf7b4141b?w=800&q=80',
    highlights: ['Low/No Tuition', 'Schengen Access', 'Global Exposure'],
  },
];

// More destinations (compact cards)
export const moreDestinations = [
  { country: 'Germany', color: 'from-amber-600 to-amber-800' },
  { country: 'Japan', color: 'from-rose-600 to-rose-800' },
  { country: 'Singapore', color: 'from-teal-600 to-teal-800' },
  { country: 'Malaysia', color: 'from-emerald-600 to-emerald-800' },
  { country: 'Russia', color: 'from-sky-600 to-sky-800' },
  { country: 'Switzerland', color: 'from-red-600 to-red-800' },
  { country: 'Sweden', color: 'from-blue-600 to-blue-800' },
  { country: 'Finland', color: 'from-cyan-600 to-cyan-800' },
  { country: 'Turkey', color: 'from-rose-500 to-rose-700' },
  { country: 'France', color: 'from-indigo-600 to-indigo-800' },
  { country: 'Dubai (UAE)', color: 'from-amber-500 to-amber-700' },
  { country: 'Armenia', color: 'from-orange-600 to-orange-800' },
  { country: 'Kazakhstan', color: 'from-sky-500 to-sky-700' },
  { country: 'Hungary', color: 'from-green-600 to-green-800' },
  { country: 'Georgia', color: 'from-violet-600 to-violet-800' },
];

// About the Founder
export const founderInfo = {
  name: 'PG Hemant Christopher',
  nickname: 'Chris Sir',
  title: 'Director & Head Faculty',
  established: '2009',
  experience: '15+',
  image: '/images/chris-sir.jpeg',
  bio: 'Founded by Mr. P.G. Hemant Christopher — lovingly known as "Chris Sir" by thousands of students — Chris IELTS Consulting has been Raipur\'s trusted name in IELTS/TOEFL coaching and study abroad consulting since 2009. With 15+ years of coaching experience, Chris Sir personally ensures every student gets a customized study plan and end-to-end support.',
  highlights: [
    'Founded Chris IELTS Consulting in 2009',
    '15+ years of IELTS/TOEFL coaching experience',
    '3000+ students guided to study abroad',
    '99% visa approval rate',
    'Personalized coaching with small batches',
    'End-to-end support from coaching to pre-departure',
  ],
};

// Team Members
export const teamMembers = [
  { name: 'PG Hemant Christopher', role: 'Director & Head Faculty', avatar: 'HC' },
  { name: 'Tanmay Sharma', role: 'Consultant', avatar: 'TS' },
  { name: 'Rahul Shrivastava', role: 'Consultant', avatar: 'RS' },
  { name: 'Richa Sharma', role: 'Consultant', avatar: 'RS' },
];

// Visa Services
export const visaServices = [
  { title: 'Canada Visa', description: 'Study, Work & PR Visa for Canada', icon: 'FileText' },
  { title: 'USA Visa', description: 'Student (F1) & Visit Visa', icon: 'FileText' },
  { title: 'Australia & NZ Visa', description: 'Study & Work Visa', icon: 'FileText' },
  { title: 'UK Visa', description: 'Student & Skilled Worker Visa', icon: 'FileText' },
  { title: 'Japan Business Visa', description: 'Business & Work Visa', icon: 'Briefcase' },
  { title: 'Japan Visit & Tourist Visa', description: 'Tourism & Sightseeing', icon: 'Plane' },
  { title: 'Visit Visa', description: 'Visit visa for all countries', icon: 'Globe' },
  { title: 'Family Visit Visa', description: 'For students studying abroad', icon: 'Heart' },
];

// Real Google Reviews
export const testimonials = [
  {
    name: 'Akshata Mahadik',
    review: 'Chris Sir provides excellent English training in an easy to understand, effective format for his IELTS class. Strongly advised for anyone looking to get better in English in preparation for the IELTS exam.',
    rating: 5,
    date: '8 Apr 2024',
    avatar: 'AM',
    source: 'Google Review',
  },
  {
    name: 'Kuldeep Singh',
    review: 'Kuldeep here from Bhilai, Chhattisgarh. I was in the morning batch and I am glad to share that in my IELTS I scored well. The coaching methodology and personal attention made all the difference.',
    rating: 5,
    date: '6 Apr 2024',
    avatar: 'KS',
    source: 'Google Review',
  },
  {
    name: 'Gurleen K Randhawa',
    review: 'I completed my whole journey from IELTS to applying for Canada visa at Chris IELTS consulting. From coaching to visa application, everything was handled professionally and with great care.',
    rating: 5,
    date: '29 Mar 2024',
    avatar: 'GR',
    source: 'Google Review',
  },
  {
    name: 'Om Soni',
    review: 'Effective teaching style. Anyone can score the desired bands you just need to follow the instructions of our beloved sir. Highly recommended for IELTS preparation in Raipur.',
    rating: 5,
    date: '27 Mar 2024',
    avatar: 'OS',
    source: 'Google Review',
    isLocalGuide: true,
  },
  {
    name: 'Reju Roy',
    review: 'Chris IELTS Consulting provides an unparalleled experience for anyone preparing for the IELTS exam. Chris Sir crafts personalized strategies that really help achieve target scores.',
    rating: 5,
    date: '22 Mar 2024',
    avatar: 'RR',
    source: 'Google Review',
  },
];

// Process Steps
export const processSteps = [
  {
    step: 1,
    title: 'Free Counseling',
    description: 'Book a free session to discuss your study abroad goals, academic profile, and budget. We create a personalized roadmap for you.',
    icon: 'MessageCircle',
  },
  {
    step: 2,
    title: 'IELTS Preparation',
    description: 'Join our proven IELTS coaching program with personalized strategies, regular mock tests, and focused band improvement modules.',
    icon: 'BookOpen',
  },
  {
    step: 3,
    title: 'University Admission',
    description: 'We shortlist universities matching your profile, prepare applications, write SOPs, and secure admission offers from top institutions.',
    icon: 'GraduationCap',
  },
  {
    step: 4,
    title: 'Visa Processing',
    description: 'Complete documentation, financial planning, and interview preparation to ensure a smooth and successful visa application.',
    icon: 'ShieldCheck',
  },
  {
    step: 5,
    title: 'Pre-Departure Support',
    description: 'Comprehensive pre-departure briefing including accommodation, banking, travel, and cultural orientation to set you up for success.',
    icon: 'Plane',
  },
];

// Contact Info
export const contactInfo = {
  address: 'HIG-II, 55, Sector 1, DDU Nagar, Amanaka, Raipur, Chhattisgarh 492013',
  phones: ['+91 92292 99937', '+91 89828 09937'],
  email: 'chris@chrisieltsconsulting.com',
  website: 'chrisieltsconsulting.in',
  whatsapp: '919229299937',
  whatsappSecondary: '918982809937',
  hours: 'Mon - Sat: 8:00 AM - 7:00 PM',
  mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14873.6!2d81.6296!3d21.2514!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dfaf1f3c650f%3A0x90cea10dd32392c3!2sChris+IELTS+Consulting!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin',
  googleMapsLink: 'https://share.google/BDfVDLctY7oKVWg0X',
  socialLinks: {
    facebook: '#',
    instagram: '#',
    youtube: '#',
    linkedin: '#',
  },
};

// Footer
export const footerData = {
  description: 'Chhattisgarh\'s most trusted IELTS & TOEFL coaching and study abroad consulting firm. Founded by PG Hemant Christopher (Chris Sir), helping students achieve their dreams of global education since 2009.',
  quickLinks: [
    { label: 'About Us', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Destinations', href: '#destinations' },
    { label: 'Reviews', href: '#testimonials' },
    { label: 'Contact', href: '#contact' },
  ],
  services: [
    { label: 'IELTS Coaching', href: '#services' },
    { label: 'Study Abroad', href: '#services' },
    { label: 'Visa Assistance', href: '#visa-services' },
    { label: 'SOP Writing', href: '#services' },
  ],
  destinations: [
    { label: 'Canada', href: '#destinations' },
    { label: 'United Kingdom', href: '#destinations' },
    { label: 'United States', href: '#destinations' },
    { label: 'Australia', href: '#destinations' },
    { label: 'New Zealand', href: '#destinations' },
    { label: 'Europe', href: '#destinations' },
  ],
};

// Blog Posts (mock)
export const blogPosts = [
  {
    id: 1,
    title: 'How to Score Band 7+ in IELTS: Complete Strategy Guide',
    excerpt: 'Master the strategies and techniques needed to achieve a high IELTS band score. From reading to speaking, we cover it all.',
    category: 'IELTS Tips',
    date: 'Jul 15, 2025',
    readTime: '8 min read',
    image: 'https://images.unsplash.com/flagged/photo-1554473675-d0904f3cbf38?w=600&q=80',
  },
  {
    id: 2,
    title: 'Canada vs Australia: Which Country to Choose for Study Abroad?',
    excerpt: 'A detailed comparison of studying in Canada vs Australia - costs, work opportunities, PR pathways, and lifestyle.',
    category: 'Study Abroad',
    date: 'Jun 28, 2025',
    readTime: '10 min read',
    image: 'https://images.unsplash.com/photo-1549529400-9ad5816f432e?w=600&q=80',
  },
  {
    id: 3,
    title: 'Complete Canada Student Visa Guide 2025',
    excerpt: 'Step-by-step guide to applying for a Canadian student visa. Documents, SOP tips, financial requirements, and interview preparation.',
    category: 'Visa Guide',
    date: 'Jun 10, 2025',
    readTime: '12 min read',
    image: 'https://images.unsplash.com/photo-1523059623039-a9ed027e7fad?w=600&q=80',
  },
  {
    id: 4,
    title: 'Top 10 Scholarships for Indian Students in UK',
    excerpt: 'Explore the best scholarship opportunities available for Indian students planning to study in the United Kingdom.',
    category: 'Scholarships',
    date: 'May 22, 2025',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1649162549612-63314ee73470?w=600&q=80',
  },
  {
    id: 5,
    title: 'IELTS Speaking Part 2: 50 Common Cue Cards with Answers',
    excerpt: 'Practice with the most frequently asked IELTS Speaking Part 2 topics. Sample answers and tips included.',
    category: 'IELTS Tips',
    date: 'May 5, 2025',
    readTime: '15 min read',
    image: 'https://images.unsplash.com/photo-1557734864-c78b6dfef1b1?w=600&q=80',
  },
  {
    id: 6,
    title: 'Japan Business Visa: Requirements and Application Process',
    excerpt: 'Everything you need to know about obtaining a Japan business visa from India. Documents, processing time, and tips.',
    category: 'Visa Guide',
    date: 'Apr 18, 2025',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1609971757431-439cf7b4141b?w=600&q=80',
  },
];

// Free Resources (mock)
export const freeResources = [
  {
    id: 1,
    title: 'IELTS Speaking Practice Questions',
    type: 'Practice Material',
    description: 'Collection of 100+ common IELTS speaking topics with sample answers and vocabulary tips.',
    icon: 'Mic',
  },
  {
    id: 2,
    title: 'IELTS Writing Task 2 Templates',
    type: 'Writing Guide',
    description: 'Essay templates and structures for all types of IELTS Writing Task 2 questions.',
    icon: 'PenTool',
  },
  {
    id: 3,
    title: 'Country Comparison Guide',
    type: 'Study Abroad',
    description: 'Comprehensive comparison of costs, lifestyle, work opportunities across 15+ study destinations.',
    icon: 'Globe',
  },
  {
    id: 4,
    title: 'SOP Writing Masterclass',
    type: 'Application Guide',
    description: 'Step-by-step guide to writing a compelling Statement of Purpose with real examples.',
    icon: 'FileText',
  },
  {
    id: 5,
    title: 'IELTS Vocabulary Builder',
    type: 'Practice Material',
    description: 'Essential vocabulary list organized by topic for IELTS Reading, Writing, and Speaking modules.',
    icon: 'BookOpen',
  },
  {
    id: 6,
    title: 'Visa Checklist Pack',
    type: 'Visa Guide',
    description: 'Country-wise visa document checklists for Canada, UK, USA, Australia, NZ, and more.',
    icon: 'CheckSquare',
  },
  {
    id: 7,
    title: 'IELTS Listening Practice Tests',
    type: 'Practice Material',
    description: 'Free sample listening tests with answer keys and audio scripts for self-practice.',
    icon: 'Headphones',
  },
  {
    id: 8,
    title: 'Scholarship Finder Guide',
    type: 'Financial Aid',
    description: 'Complete guide to finding and applying for scholarships in top study abroad destinations.',
    icon: 'Award',
  },
];
